(() => {
  'use strict';
  if (window.EcomDiscoveryAPI) return;
  const labelsNode = document.querySelector('[data-ecom-discovery-labels]');
  if (!labelsNode) return;
  let labels;
  try { labels = JSON.parse(labelsNode.textContent); } catch { return; }
  const label = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`[${name}]`, String(value)), labels[key] || key);
  const idOK = value => /^\d{8,20}$/.test(String(value));
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const wordAliases = { tshirt: 'tee', tshirts: 'tee', tees: 'tee', caps: 'cap', hats: 'cap', hat: 'cap' };
  const tokens = value => normalize(value).replace(/\bt shirts?\b/g, 'tee').split(/\s+/).filter(Boolean).map(word => wordAliases[word] || word);
  const matches = (record, query, type, size) => {
    if (type && record.type !== type) return false;
    if (size && !record.variants.some(variant => variant.available && variant.size === size)) return false;
    const corpus = tokens([record.title, record.type, record.material, record.fit, record.decoration, record.description, ...record.variants.map(variant => `${variant.title} ${variant.sku || ''}`)].join(' '));
    const haystack = corpus.join(' ');
    return tokens(query).every(word => haystack.includes(word));
  };
  const oneEditApart = (a, b) => {
    if (a === b || Math.abs(a.length - b.length) > 1) return false;
    let i = 0, j = 0, edits = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++edits > 1) return false;
      if (a.length <= b.length) j++;
      if (a.length >= b.length) i++;
    }
    return edits + (i < a.length || j < b.length ? 1 : 0) === 1;
  };
  const suggest = (products, query) => {
    const words = tokens(query);
    if (!words.length || words.length > 6) return [];
    const vocabulary = [...new Set(products.flatMap(product => tokens([product.title, product.type, product.material, product.fit].join(' '))))].filter(word => /^[a-z]{4,}$/.test(word));
    const suggestions = [];
    words.forEach((word, index) => {
      if (!/^[a-z]{4,}$/.test(word) || vocabulary.includes(word)) return;
      vocabulary.filter(candidate => oneEditApart(word, candidate)).forEach(candidate => {
        const replacement = [...words]; replacement[index] = candidate;
        const value = replacement.join(' ');
        if (products.some(product => matches(product, value, '', ''))) suggestions.push(value);
      });
    });
    return [...new Set(suggestions)].slice(0, 3);
  };
  const keys = { saved: 'ecom-bro-saved-v1', recent: 'ecom-bro-recent-v1', compare: 'ecom-bro-compare-v1', browse: 'ecom-bro-browse-v1' };
  const memory = {};
  let storageAvailable = true;
  const read = (key, fallback, session = false) => {
    try { return JSON.parse((session ? sessionStorage : localStorage).getItem(key)) || fallback; }
    catch { storageAvailable = false; return memory[key] || fallback; }
  };
  const write = (key, value, session = false) => {
    memory[key] = value;
    try { (session ? sessionStorage : localStorage).setItem(key, JSON.stringify(value)); return true; }
    catch { storageAvailable = false; return false; }
  };
  const readSaved = () => {
    const value = read(keys.saved, []);
    return new Set(Array.isArray(value) ? value.filter(idOK).map(String).slice(0, 50) : []);
  };
  let saved = readSaved();
  const rawRecent = read(keys.recent, []);
  let recent = Array.isArray(rawRecent) ? rawRecent.filter(entry => entry && idOK(entry.id) && Number.isFinite(entry.at) && entry.at > Date.now() - 30 * 86400000 && entry.at <= Date.now()).slice(0, 12) : [];
  const currentProduct = document.querySelector('[data-ecom-current-product]');
  if (currentProduct && idOK(currentProduct.dataset.ecomCurrentProduct)) {
    const id = currentProduct.dataset.ecomCurrentProduct;
    recent = [{ id, at: Date.now() }, ...recent.filter(entry => entry.id !== id)].slice(0, 12);
    write(keys.recent, recent);
    currentProduct.hidden = false;
  }
  const say = message => document.querySelectorAll('[data-ecom-storage-status]').forEach(node => { node.textContent = message; });
  const refreshSaved = () => document.querySelectorAll('[data-ecom-save]').forEach(button => {
    const selected = saved.has(button.dataset.ecomSave);
    button.setAttribute('aria-pressed', String(selected));
    button.textContent = label(selected ? 'saved' : 'save');
    const card = button.closest('[data-ecom-card]');
    const title = card?.querySelector('h3')?.textContent || document.querySelector('.ecom-purchase h1')?.textContent;
    if (title) button.setAttribute('aria-label', `${button.textContent}: ${title.trim()}`);
  });
  const records = new Map();
  document.querySelectorAll('[data-ecom-product-record]').forEach(node => {
    try { const record = JSON.parse(node.textContent); if (idOK(record.id) && Array.isArray(record.variants)) records.set(String(record.id), record); } catch { /* A malformed record does not disable native product links. */ }
  });
  const root = document.querySelector('[data-ecom-discovery]');
  let render = () => {};
  document.querySelectorAll('[data-ecom-card-tools]').forEach(node => { node.hidden = false; });
  if (!root) document.querySelectorAll('[data-ecom-compare-label]').forEach(node => { node.hidden = true; });
  document.querySelectorAll('[data-ecom-save]').forEach(button => button.addEventListener('click', () => {
    const id = button.dataset.ecomSave;
    if (!idOK(id)) return;
    const removing = saved.has(id);
    if (removing) saved.delete(id); else saved.add(id);
    const stored = write(keys.saved, [...saved].slice(-50));
    refreshSaved();
    say(stored ? label(removing ? 'removed_notice' : 'saved_notice') : label('storage_unavailable'));
    render();
    if (removing && button.closest('[data-ecom-card]')?.hidden) root?.querySelector('[data-ecom-view]')?.focus();
  }));
  refreshSaved();
  if (!storageAvailable) say(label('storage_unavailable'));

  // Return links are restricted to this collection and never accept external destinations.
  const collectionURL = root?.dataset.ecomCollectionUrl || currentProduct?.dataset.ecomCollectionUrl;
  if (collectionURL) {
    const previous = read(keys.browse, null, true);
    if (previous && typeof previous.url === 'string') {
      try {
        const url = new URL(previous.url, location.origin);
        const allowed = new URL(collectionURL, location.origin);
        if (url.origin === location.origin && url.pathname === allowed.pathname) {
          document.querySelectorAll('[data-ecom-back-link]').forEach(link => { link.href = `${url.pathname}${url.search}#TheCollection`; });
        }
      } catch { /* Keep the server-rendered collection link. */ }
    }
  }
  if (root) {
    const controls = root.querySelector('[data-ecom-discovery-controls]');
    const query = root.querySelector('[data-ecom-query]');
    const type = root.querySelector('[data-ecom-type]');
    const size = root.querySelector('[data-ecom-size]');
    const view = root.querySelector('[data-ecom-view]');
    const cards = [...root.querySelectorAll('[data-ecom-card]')];
    const orderable = [...records.values()].filter(record => record.orderable);
    const populate = (select, values) => [...new Set(values.filter(Boolean))].forEach(value => select.add(new Option(value, value)));
    populate(type, orderable.map(record => record.type));
    const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', '4XL', '5XL'];
    const sizeValues = [...new Set(orderable.flatMap(record => record.variants.filter(variant => variant.available).map(variant => variant.size)).filter(Boolean))];
    sizeValues.sort((a, b) => (sizeOrder.indexOf(a) < 0 ? 99 : sizeOrder.indexOf(a)) - (sizeOrder.indexOf(b) < 0 ? 99 : sizeOrder.indexOf(b)) || a.localeCompare(b));
    populate(size, sizeValues);
    type.closest('label').hidden = type.options.length < 3;
    size.closest('label').hidden = size.options.length < 3;
    const paramsFor = () => ({ ecom_q: query.value.trim(), ecom_type: type.value, ecom_size: size.value, ecom_view: view.value });
    const fromURL = () => {
      const params = new URL(location.href).searchParams;
      query.value = (params.get('ecom_q') || '').slice(0, 160);
      [type, size].forEach((select, i) => { const value = params.get(i ? 'ecom_size' : 'ecom_type') || ''; select.value = [...select.options].some(option => option.value === value) ? value : ''; });
      view.value = ['saved', 'recent'].includes(params.get('ecom_view')) ? params.get('ecom_view') : '';
      if (type.value || size.value || view.value) root.querySelector('.ecom-discovery-options').open = true;
    };
    const remember = () => write(keys.browse, { url: `${location.pathname}${location.search}`, at: Date.now() }, true);
    const updateURL = () => {
      const url = new URL(location.href);
      Object.entries(paramsFor()).forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
      history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`);
      remember();
    };
    const chip = (name, value, clear) => {
      if (!value) return;
      const button = document.createElement('button'); button.type = 'button';
      button.textContent = `${name}: ${value} ×`; button.setAttribute('aria-label', `${label('remove')} ${name}: ${value}`);
      button.addEventListener('click', () => { clear(); updateURL(); render(); query.focus(); });
      root.querySelector('[data-ecom-active]').append(button);
    };
    render = () => {
      let count = 0, unavailable = 0;
      const recentIDs = new Set(recent.map(entry => String(entry.id)));
      cards.forEach(card => {
        const record = records.get(card.dataset.ecomCard);
        if (!record) return;
        const visible = matches(record, query.value, type.value, size.value) && (view.value !== 'saved' || saved.has(record.id)) && (view.value !== 'recent' || recentIDs.has(record.id));
        card.hidden = !visible;
        if (visible) { if (record.orderable) count++; else unavailable++; }
      });
      root.querySelector('[data-ecom-result-count]').textContent = label('count', { count });
      root.querySelector('[data-ecom-empty]').hidden = count > 0;
      const suggestions = root.querySelector('[data-ecom-search-suggestions]');
      suggestions.replaceChildren();
      if (!count && query.value.trim()) suggest(orderable, query.value).forEach(value => {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = label('try_query', { query: value });
        button.addEventListener('click', () => { query.value = value; updateURL(); render(); query.focus(); }); suggestions.append(button);
      });
      const unavailableNode = root.querySelector('[data-ecom-unavailable]');
      if (unavailableNode) unavailableNode.hidden = unavailable === 0;
      root.querySelector('[data-ecom-active]').replaceChildren();
      chip(label('filter_query'), query.value.trim(), () => { query.value = ''; });
      chip(label('filter_type'), type.value, () => { type.value = ''; });
      chip(label('filter_size'), size.value, () => { size.value = ''; });
      if (view.value) chip(label(view.value === 'saved' ? 'view_saved' : 'view_recent'), view.value === 'saved' ? String(saved.size) : String(recent.length), () => { view.value = ''; });
      root.querySelector('.ecom-discovery-result-row [data-ecom-reset]').hidden = !Object.values(paramsFor()).some(Boolean);
      root.querySelector('[data-ecom-clear-storage]').hidden = !view.value;
      const sortForm = root.querySelector('[data-ecom-sort-form]');
      sortForm.querySelectorAll('[data-ecom-sort-state]').forEach(node => node.remove());
      Object.entries(paramsFor()).filter(([, value]) => value).forEach(([name, value]) => {
        const input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.value = value; input.dataset.ecomSortState = ''; sortForm.append(input);
      });
    };
    let searchTimer;
    query.addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(() => { updateURL(); render(); }, 180); });
    root.querySelector('[data-ecom-search-form]').addEventListener('submit', event => { event.preventDefault(); clearTimeout(searchTimer); updateURL(); render(); });
    [type, size, view].forEach(select => select.addEventListener('change', () => { updateURL(); render(); }));
    root.querySelectorAll('[data-ecom-reset]').forEach(button => button.addEventListener('click', () => { clearTimeout(searchTimer); query.value = ''; type.value = ''; size.value = ''; view.value = ''; updateURL(); render(); query.focus(); }));
    root.querySelector('[data-ecom-clear-storage]').addEventListener('click', () => {
      if (view.value === 'saved') { saved.clear(); write(keys.saved, []); refreshSaved(); }
      if (view.value === 'recent') { recent = []; write(keys.recent, []); }
      say(label('cleared')); render();
    });
    root.addEventListener('click', event => { if (event.target.closest('[data-ecom-card] a')) remember(); });
    window.addEventListener('popstate', () => { fromURL(); render(); });
    fromURL(); render(); controls.hidden = false;

    const storedCompare = read(keys.compare, [], true);
    let comparison = new Set((Array.isArray(storedCompare) ? storedCompare : []).map(String).filter(id => records.get(id)?.orderable).slice(0, 3));
    const compareStatus = root.querySelector('[data-ecom-compare-status]');
    const refreshCompare = () => {
      root.querySelectorAll('[data-ecom-compare]').forEach(input => { input.checked = comparison.has(input.value); });
      const open = root.querySelector('[data-ecom-open-compare]');
      open.disabled = comparison.size < 2; open.textContent = label('compare_count', { count: comparison.size });
      root.querySelector('[data-ecom-clear-compare]').hidden = !comparison.size;
      write(keys.compare, [...comparison], true);
    };
    root.querySelectorAll('[data-ecom-compare]').forEach(input => input.addEventListener('change', () => {
      if (input.checked && comparison.size >= 3 && !comparison.has(input.value)) { input.checked = false; compareStatus.textContent = label('compare_limit'); return; }
      if (input.checked) comparison.add(input.value); else comparison.delete(input.value);
      compareStatus.textContent = ''; refreshCompare();
    }));
    root.querySelector('[data-ecom-clear-compare]').addEventListener('click', () => { comparison.clear(); compareStatus.textContent = label('compare_empty'); refreshCompare(); });
    const dialog = root.querySelector('[data-ecom-compare-dialog]');
    const make = (tag, text) => { const node = document.createElement(tag); if (text !== undefined) node.textContent = text; return node; };
    root.querySelector('[data-ecom-open-compare]').addEventListener('click', () => {
      const products = [...comparison].map(id => records.get(id)).filter(Boolean);
      if (products.length < 2) return;
      const table = make('table'); const caption = make('caption', label('compare_count', { count: products.length })); caption.className = 'ecom-visually-hidden'; table.append(caption);
      const head = make('thead'); const heading = make('tr'); const corner = make('th', label('type')); corner.scope = 'col'; heading.append(corner);
      products.forEach(product => {
        const cell = make('th'); cell.scope = 'col';
        if (product.image) { const image = make('img'); image.src = product.image; image.alt = ''; image.width = 120; image.height = 120; image.loading = 'lazy'; cell.append(image); }
        const link = make('a', product.title); link.href = product.url; cell.append(link); heading.append(cell);
      });
      head.append(heading); table.append(head); const body = make('tbody');
      ['price', 'type', 'material', 'fit', 'decoration', 'sizes'].forEach(key => {
        if (key === 'decoration' && products.every(product => !product.decoration)) return;
        const row = make('tr'); const name = make('th', label(key)); name.scope = 'row'; row.append(name);
        products.forEach(product => {
          const value = key === 'sizes' ? [...new Set(product.variants.filter(variant => variant.available).map(variant => variant.size).filter(Boolean))].join(', ') : product[key];
          row.append(make('td', value || label('details')));
        }); body.append(row);
      }); table.append(body); root.querySelector('[data-ecom-compare-content]').replaceChildren(table); dialog.showModal();
    });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
    refreshCompare();
  }
  let cartRequest = 0;
  const refreshCart = async () => {
    if (!document.querySelector('[data-ecom-in-bag]')) return;
    const request = ++cartRequest;
    try {
      const route = root?.dataset.cartUrl || `${window.Shopify?.routes?.root || '/'}cart.js`;
      const response = await fetch(route, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (request !== cartRequest || !Array.isArray(cart.items)) return;
      const counts = new Map(); cart.items.forEach(item => counts.set(String(item.product_id), (counts.get(String(item.product_id)) || 0) + item.quantity));
      document.querySelectorAll('[data-ecom-in-bag]').forEach(node => { const count = counts.get(node.dataset.ecomInBag) || 0; node.hidden = !count; node.textContent = label('in_bag', { count }); });
    } catch { /* Keep the server-rendered cart state when the refresh fails. */ }
  };
  window.addEventListener('ecom:cart-updated', refreshCart);
  window.addEventListener('pageshow', event => { saved = readSaved(); refreshSaved(); render(); if (event.persisted) refreshCart(); });
  window.addEventListener('storage', event => { if (event.key === keys.saved) { saved = readSaved(); refreshSaved(); render(); } });
  refreshCart();
  window.EcomDiscoveryAPI = { normalize, tokens, matches, oneEditApart, suggest, refreshCart };
})();
